import { Grid, useAutocomplete } from "@pankod/refine-mui";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  disabled,
}) {
  const { autocompleteProps: typeAC } = useAutocomplete({
    resource: "facility-service-types",
    pagination: {
      pageSize: 100,
    },
    metaData: {
      populate: "deep,2",
    },
    onSearch: (value) => [
      {
        field: "name",
        operator: "contains",
        value,
      },
    ],
  });

  const fields = [
    {
      label: "Name",
      name: "name",
      required: true,
      type: "text",
      localized: true,
    },
    {
      label: "Description",
      name: "description",
      required: false,
      type: "text",
      lines: 4,
      localized: true,
    },
    {
      label: "Tipologia servizio",
      name: "facility_service_type",
      accessor: "name",
      options: typeAC,
      required: true,
      type: "autocomplete",
    },
  ];

  return (
    <Grid container spacing={2}>
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            {...field}
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            fieldVariants="outlined"
            defaultValue={watch(field.name)}
            defaultLanguageRecord={defaultLanguageRecord}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
            disabled={disabled}
          />
        );
      })}
    </Grid>
  );
}
